export { default } from './MultiTextList'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextList/index.js